export const GridContainer = ({ children, columns = {}, className = "" }) => {    
    const base = columns.base ? `grid-cols-${columns.base}` : "";
    const sm = columns.sm ? `sm:grid-cols-${columns.sm}` : "";
    const md = columns.md ? `md:grid-cols-${columns.md}` : "";
    const lg = columns.lg ? `lg:grid-cols-${columns.lg}` : "";

    return (
        <div className={`h-full grid gap-3 ${base} ${sm} ${md} ${lg} ${className}`}>
            {children}
        </div>
    );
};